<template>
    <div class="materialReport">
        <!-- <el-button type="primary" @click="getPdf('#pdfdom')">下载报告</el-button> -->
        <div class="btns">
            <el-button type="primary" @click="createPage">下载报告</el-button>
            <el-button type="primary" @click="back">返回</el-button>
        </div>
        <div class="dingmei">
            <div class="tops" id="top">
                <div class="top">
                    <div class="l">
                        <span class="l-t">天信公估</span>
                        <span class="l-b">TIANXIN  ADJUSTERS</span>
                    </div>
                    <div class="r">
                        委托编号:
                        <span class="r-r">{{caseNo}}号</span>
                    </div>
                </div>
            </div>
        </div>
        
        <div id="pdfdom" class="pdf">
            <div class="title">价格评估委托准许书</div>
            <div class="p">
                <span class="span0">广州天信保险公估有限公司受</span><span class="span1"></span>
                <span>委托,对</span><span class="span2"></span>
                <span>于</span><span class="span3"></span>
                <span>年</span><span class="span3"></span>
                <span>月</span><span class="span3"></span>
                <span>日所遭受的损失进行价格鉴定处理。为了保障委托方的合法</span>法权益，在我司人员进入评估工作之前，仍须得到委托人的准许方可正式生效。
            </div>
            <table class="table" border="1" style="border-collapse: collapse;">
                <tr>
                    <td rowspan="3" class="td0">委托人</td><td class="td1">名 称</td><td colspan="3"></td>
                </tr>
                <tr>
                    <td class="td1">地 址</td><td colspan="3"></td>
                </tr>
                <tr>
                    <td class="td1">联系人</td><td></td><td class="td1">电 话</td><td></td>
                </tr>

                <tr>
                    <td colspan="2">准许内容(在框内打√)</td>
                    <td colspan="3">
                        <div class="td-con">
                            <div class="item">
                                <div class="icon-y"></div>
                                <div class="item-v">现场勘察</div> 
                            </div>
                            <div class="item">
                                <div class="icon-y"></div>
                                <div class="item-v">价格鉴定</div> 
                            </div>
                            <div class="item">
                                <div class="icon-f"></div>
                                <div class="item-v">理算理赔</div> 
                            </div>
                            <div class="item">
                                <div class="icon-f"></div>
                                <div class="item-v">聘请专家或其它</div> 
                            </div>
                        </div>
                        
                    </td>
                </tr>
            </table>
            <div class="tip">
                <div class="title">准许人须知：</div>
                <div class="item">1、本单是委托评估合同的简易凭证，其法律效力与委托合同相同；</div>
                <div class="item">2、为了使贵司（或个人）能够得到及时公平的处理，应尽可能按照评估人员出具的材料清单备齐所需资料；</div>
                <div class="item">3、本单如无特别协商注明，贵司（或个人）按评估收费标准支付费用（基础费
                    <span style="width:40px"></span>
                    元+价格评估总金额<span style="width:20px"></span>%收取，评估费在出具终期报告、发票后完成支付）。</div>
            </div>


            <div class="jc">
                谨此
            </div>
            <div class="xx">
                谢谢您的支持！
            </div>
            <div class="info">
                <div class="wtr">委托人：</div>
                <div class="wtgs">受托公司：广州天信保险公估有限公司</div>
            </div>
            <div class="date">
                <div class="item">日   期：</div>
                <div class="item item2">日   期：</div>
            </div>
        </div>

        <div class="pages">
        </div>
        <div class="dingmeiimg"></div>

        <div class="backtop" @click="backTop">
            <i class="el-icon-top"></i>
        </div>
    </div>
</template>
<script>
import api from '../../../api/main'
import html2Canvas from 'html2canvas'
import store from '../../../store'

// import { provinceAndCityData , CodeToText } from "element-china-area-data";

export default {
    name: 'entrustMaterial',
    components:{
        
    },
    watch: {
    },
    data () {
        return {
            detail:{},
            page:1,
            htmlTitle:'价格评估委托准许书',
            scale:4,
            caseNo:'',
        }
    },
    created(){
    },
    mounted(){
        this.caseNo = this.$route.query.caseNo;
    },
    methods:{
        
        backTop(){
            document.querySelector('.el-main').scrollTop = 0

        },
        biaotou(){
            document.querySelector('.el-main').scrollTop = 0

            let _this = this;
            html2Canvas(document.getElementById('top'),{
                    backgroundColor: null, // 背景颜色
                    dpi: 192, // 将分辨率提高到特定的dpi,默认值为96
                    scale: this.scale, // 用于渲染的比例尺。默认为浏览器设备像素比率。默认值是1，手机端设置成2
                    useCORS:true, // 是否尝试使用CORS从服务器加载图像
                    scrollY: 0, 
                    scrollX: 0,
            }).then((canvas) => {
                _this.convertCanvasToImage(canvas);
            })
        },
        convertCanvasToImage(canvas) {
            // document.getElementById('top').remove();
            var imgStr = canvas.toDataURL("image/png");
            var img=new Image();
            img.src=imgStr;
            img.setAttribute('class', 'biaotou')
            document.querySelector('.dingmeiimg').append(img);
            this.getPdf('#pdfdom')
        },
        createPage(){
            this.page=1;
            store.dispatch('global/setLoading', true);
            var canvas = document.getElementById('pdfdom');
            var a4Width = 595.28;
            var a4Height = 701.89;
            var a4HeightRef = Math.floor((canvas.offsetWidth / a4Width) * a4Height)
            var p = canvas.offsetHeight/a4HeightRef;
            var pages = document.querySelector('.pages');
            for(let i = 0;i < p+2;i++){
                pages.innerHTML = pages.innerHTML + '<div class="page page'+this.page+'" style="width: 880px;font-size: 14px;text-align: center;">第'+this.page+'页</div>';
                this.pageToCanvas('page'+this.page);
                this.page = this.page+1;
            }

            this.biaotou();
        },
        pageToCanvas(page){
            console.log(page);
            let _this = this;
            html2Canvas(document.querySelector('.'+page),{
                    backgroundColor: null, // 背景颜色
                    dpi: 120, // 将分辨率提高到特定的dpi,默认值为96
                    scale: 1, // 用于渲染的比例尺。默认为浏览器设备像素比率。默认值是1，手机端设置成2
                    useCORS:true, // 是否尝试使用CORS从服务器加载图像
                    scrollY: 0, 
                    scrollX: 0,
            }).then((canvas) => {
                _this.pageCanvasToImage(canvas,page);
            })
        },
        pageCanvasToImage(canvas, className){
            var imgStr = canvas.toDataURL("image/png");
            var img=new Image();
            img.src=imgStr;
            img.setAttribute('class', 'img'+className)
            document.querySelector('.pages').append(img);
            // this.getPdf('#pdfdom')

        },
       
        async queryAssetsMaterialDamage(){
            
           
           
        },
        CNDateString(date){
            var cn = ["〇","一","二","三","四","五","六","七","八","九"];
            var s = [];
            var YY = date.getFullYear().toString();
            for (var i=0; i<YY.length; i++)
            if (cn[YY.charAt(i)])
            s.push(cn[YY.charAt(i)]);
            else
            s.push(YY.charAt(i));
            s.push("年");
            var MM = date.getMonth()+1;
            if (MM<10)
            s.push(cn[MM]);
            else if (MM<20)
            s.push("十" + cn[MM% 10]);
            s.push("月");
            var DD = date.getDate();
            if (DD<10)
            s.push(cn[DD]);
            else if (DD<20)
            s.push("十" + cn[DD% 10]);
            else if (DD<30)
            s.push("二十" + cn[DD% 10]);
            else
            s.push("三十" + cn[DD% 10]);
            s.push("日");
            return s.join('');
        },
        back(){
            this.$router.go(-1)
        },
       
        
    }
    
}
</script>

<style lang="scss" scoped>
   
    .materialReport{
        // font-family: 'simsun';
        background-color: #ffffff;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 20px;
        .dingmei{
            margin-top: 20px;
        }
        .backtop{
            box-shadow: 0 4px 4px rgba(0,21,41,.1);
            width: 60px;
            height: 60px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            position: fixed;
            right: 50px;
            bottom: 100px;
            font-size: 36px;
            background-color: rgba(0, 0, 0, 0.2);
            color: #ffffff;
            cursor: pointer;
        }
        .tops{
            padding: 0 100px;
            // .biaotou{
            //     width: 880px;
            // }
        }
        .top{
            width: 680px;
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid #000000;
            .l{
                display: flex;
                flex-direction: column;
                .l-t{
                    font-size: 24px;
                }
                .l-b{
                    font-size: 16px;
                    margin-top: 4px;
                }
            }
            .r{
                font-size: 24px;
                span{
                    color: red;
                    font-size: 18px;
                    text-decoration: underline;
                }
            }
        }
        .pdf{
            // border: 1px solid #000000;
            width: 680px;
            padding: 0 100px;
            padding-top: 14px;
            .title{
                font-size: 26px;
                font-weight: bold;
                text-align: center;
                letter-spacing: 2px;
                margin-bottom: 50px;
            }
            .p{ 
                display: flex;
                flex-wrap: wrap;
                font-size: 19px;
                line-height: 42px;
                .span0{
                    text-indent: 2em;
                }
                .span1{
                    width: 198px;
                    height: 26px;
                    border-bottom: 1px solid #000000;
                }
                .span2{
                     width: 110px;
                    height: 26px;
                    border-bottom: 1px solid #000000;
                }
                .span3{
                    width: 49px;
                    height: 26px;
                    border-bottom: 1px solid #000000;
                }
            }
            .table{
                font-size: 19px;
                width: 100%;
                margin-top: 45px;
                td{
                    text-align: center;
                    padding: 6px;
                }
                .td0{
                    width: 120px;
                }
                .td1{
                    width: 80px;
                }
                .td-con{
                    display: flex;
                    flex-wrap: wrap;
                    .item{
                        display: flex;
                        align-items: center;
                        margin: 6px;
                        margin-right: 30px;
                        .icon-y{
                            width:6px;
                            height: 6px;
                            border: 6px solid #000000;
                            border-radius: 50%;
                        }
                        .icon-f{
                            width:16px;
                            height: 16px;
                            border: 1px solid #000000;
                        }
                        .item-v{
                            line-height: 18px;
                            margin-left: 10px;
                        }
                    }
                }
            }
            .tip{
                .title{
                    font-size: 22px;
                    text-align: left;
                    margin: 30px 0;
                }
                .item{
                    font-size: 19px;
                    line-height: 40px;
                    display: flex;
                    flex-wrap: wrap;
                }
            }
            .jc{
                font-size: 19px;
                margin-left: 40px;
                margin-top: 36px;
            }
            .xx{
                font-size: 19px;
                margin-top: 18px;
            }
            .info{
                display: flex;
                justify-content: space-between;
                font-size: 19px;
                margin-top: 80px;
                .wtr{
                    padding-left: 36px;
                }
                .wtgs{
                    padding-left: 36px;
                    width: 330px;
                }
            }
            .date{
                display: flex;
                justify-content: space-between;
                font-size: 19px;
                margin-top: 50px;
                .item{
                    padding-left: 36px;
                }
                .item2{
                    width: 330px;
                }
            }
        }
        
    }
    .pages{
        width: 880px;
        .page{
            width: 880px;font-size: 14px;text-align: center;
            display: flex;
            justify-content: center;
        }
    }
</style>
